import {
  GET_CART,
  ADD_TO_CART,
  DELETE_FROM_CART,
  CART_LOADING,
  GET_ITEMS_CART,
  ADD_ITEM_TO_CART,
  DELETE_ITEM_FROM_CART,
  CART_ITEM_LOADING,
  UPDATE_CART_ITEM_QUANTITY,
} from "../types/cartTypes";

const initialState = {
  cart: null,           
  cartItem: [],         
  loading: false,      
  loadingCartItem: false
};

export const cartReducer = (state = initialState, action) => {
  const { type, payload, meta } = action;

  switch (type) {
    // ---- Cart (header/summary) ----
    case CART_LOADING:
      return { ...state, loading: true };

    case GET_CART:
    case ADD_TO_CART:
    case DELETE_FROM_CART:
      return {
        ...state,
        cart: payload || state.cart,
        loading: false
      };

    // ---- Cart Items (detail list) ----
    case CART_ITEM_LOADING:
      return { ...state, loadingCartItem: true };

    case GET_ITEMS_CART:
      return {
        ...state,
        cartItem: Array.isArray(payload) ? payload : [],
        loadingCartItem: false
      };

    case ADD_ITEM_TO_CART:
      // Rely on a refresh (getItemsCart) if you need an up-to-date list;
      // keep this lightweight and just stop loading spinner.
      return { ...state, loadingCartItem: false };

    case DELETE_ITEM_FROM_CART:
      // Optimistically remove if meta.itemId provided; otherwise just stop spinner.
      return {
        ...state,
        cartItem: meta?.itemId
          ? state.cartItem.filter((ci) => ci.id !== meta.itemId)
          : state.cartItem,
        loadingCartItem: false
      };

    case UPDATE_CART_ITEM_QUANTITY:
      return {
        ...state,
        cartItem: state.cartItem.map((item) =>
          item.id === payload.id ? { ...item, quantity: payload.quantity } : item
        ),
        loadingCartItem: false
      };

    default:
      return state;
  }
};

export default cartReducer;
